import { useState } from "react";
import { ICourseNode } from "../datastructures/dataviz";
import "../styles/sidebar.css";
import "../styles/coursenode.css";
import { BsArrowsExpand, BsArrowsCollapse } from "react-icons/bs";

export type SidebarProps = {
  focusedNode: ICourseNode | undefined;
  setFocusedNode: any;
};

export const Sidebar = ({ focusedNode, setFocusedNode }: SidebarProps) => {
  const [descriptionExpanded, setDescrExpanded] = useState(false);
  const DESCRIPTION_LENGTH = 324;

  return (
    <div className="sidebar flex flex-col resize">
      <div className="flex flex-row border-t border-l border-r border-black px-3 py-1 bg-gray-900 ">
        <div className=" text-white flex-grow font-mono">
          <span className="text-violet-300 font-semibold">ECEIris &gt;</span>{" "}
          <span className="opacity-90 hover:text-yellow-300">
            {" "}
            ~/
            {focusedNode?.data.courseAreas?.includes(0)
              ? "core"
              : "area-" + focusedNode?.data.courseAreas?.join("&")}
            /<strong>{focusedNode?.data.courseCode}</strong>{" "}
          </span>
        </div>
        <button
          onClick={() => setFocusedNode(null)}
          autoFocus
          id="button-close-sidebar-toggle"
        >
          <i className="text-red-500 fa fa-times-circle close-button"></i>
        </button>
      </div>

      <div className="sidebar-internal shadow-md rounded-r-sm bg-gray-50 flex flex-col flex-grow z-10 border border-black">
        <div className="sidebar-header p-3 flex flex-row">
          <div className="sidebar-header-left flex-grow">
            <div className="font-bold  text-lg align-baseline flex flex-row">
              <p className="flex-grow">{focusedNode?.data.courseCode}</p>
              {focusedNode?.data.courseAreas?.map((area) => {
                return (
                  <div
                    className={
                      "area-" +
                      area +
                      " mx-1 px-1 rounded-lg shadow-sm  border border-black text-center font-semibold"
                    }
                  >
                    {ParseAreaToLabel(area)}
                  </div>
                );
              })}
              {focusedNode?.data.courseIsKernel ? (
                <div
                  className={
                    "bg-yellow-100 mx-1 px-1 rounded-lg shadow-sm border border-black font-semibold"
                  }
                >
                  {/* <i className=' fa fa-star'></i> */}★ Kernel
                </div>
              ) : null}
            </div>
            <div className="text-md">
              <p>{focusedNode?.data.courseName}</p>
            </div>
          </div>
          <div className="sidebar-header-right"></div>
        </div>
        <div className="sidebar-preview p-3 flex-grow">
          <p className="course-description text-sm">
            <span>
              {focusedNode?.data.courseDescr.slice(
                0,
                descriptionExpanded
                  ? focusedNode?.data.courseDescr.length
                  : DESCRIPTION_LENGTH
              )}
              {!descriptionExpanded &&
              focusedNode?.data.courseDescr.length! > DESCRIPTION_LENGTH
                ? "..."
                : null}
            </span>
            {focusedNode != null &&
            focusedNode?.data.courseDescr.length > DESCRIPTION_LENGTH ? (
              <span>
                <button
                  className="expand-button mx-1"
                  onClick={() => {
                    setDescrExpanded(!descriptionExpanded);
                  }}
                >
                  {!descriptionExpanded ? (
                    <BsArrowsExpand />
                  ) : (
                    <BsArrowsCollapse />
                  )}
                </button>
              </span>
            ) : null}
          </p>
        </div>

        <div className="sidebar-bottom p-3 text-sm">
          <div className="sidebar-relations">
            {focusedNode?.data.prerequisite ? (
              <div>
                <p className="text-lg">Prerequisites</p>
                <p className="font-bold bg-blue-300 p-2">
                  {focusedNode?.data.prerequisite}
                </p>
                {focusedNode?.data.courseCoreqs[0] !== "none" &&
                  focusedNode?.data.courseCoreqs.map((p) => {
                    return (
                      <p
                        className="font-bold bg-red-300 p-2"
                        key={"opreq-sidebar-" + p}
                      >
                        {p}{" "}
                        <abbr title="This is an corequisite, you must take this course in the same or immediately previous semester to the focused course.">
                          (Corequisite)
                        </abbr>
                      </p>
                    );
                  })}
                {focusedNode?.data.courseOptPrereqs[0] !== "none" &&
                  focusedNode?.data.courseOptPrereqs.map((p) => {
                    return (
                      <p
                        className="font-bold bg-red-300 p-2"
                        key={"ocoreq-sidebar-" + p}
                      >
                        {" "}
                        {p}{" "}
                        <abbr title="This is an OR prerequisite, you may take this either course or the other one listed here as a prerequisite for the focused course.">
                          (OR-Type Prerequisite)
                        </abbr>
                      </p>
                    );
                  })}
              </div>
            ) : (
              <>
                <p className="text-lg">Prerequisites</p>
                {((focusedNode?.data.courseCoreqs[0] === "none" &&
                  focusedNode?.data.courseOptPrereqs[0] === "none") ||
                  focusedNode?.data.coursePrereqs[0] !== "none") &&
                  focusedNode?.data.coursePrereqs.map((p) => {
                    return (
                      <p
                        className="font-bold bg-blue-300 p-2"
                        key={"std-prereq-sidebar-" + p}
                      >
                        {" "}
                        {p.charAt(0).toUpperCase() + p.slice(1)}
                      </p>
                    );
                  })}
                {focusedNode?.data.courseCoreqs[0] !== "none" &&
                  focusedNode?.data.courseCoreqs.map((p) => {
                    return (
                      <p
                        className="font-bold bg-red-300 p-2"
                        key={"opreq-sidebar-" + p}
                      >
                        {p}{" "}
                        <abbr title="This is an corequisite, you must take this course in the same or immediately previous semester to the focused course.">
                          (Corequisite)
                        </abbr>
                      </p>
                    );
                  })}
                {focusedNode?.data.courseOptPrereqs[0] !== "none" &&
                  focusedNode?.data.courseOptPrereqs.map((p) => {
                    return (
                      <p
                        className="font-bold bg-red-300 p-2"
                        key={"ocoreq-sidebar-" + p}
                      >
                        {" "}
                        {p}{" "}
                        <abbr title="This is an OR prerequisite, you may take this either course or the other one listed here as a prerequisite for the focused course.">
                          (OR-Type Prerequisite)
                        </abbr>
                      </p>
                    );
                  })}
                {/* Related */}
                {focusedNode?.homeArea === 0 && (
                  <p className="text-lg">
                    <abbr title="These courses are not strictly prerequisites, but are closely related. This designation only exists between courses in the core Y1/Y2 area.">
                      (Related Courses)
                    </abbr>
                  </p>
                )}
                {focusedNode?.homeArea === 0 &&
                  focusedNode?.data.courseRelated.map((p) => {
                    return (
                      <p
                        className="font-bold bg-green-300 p-2"
                        key={"related-sidebar-" + p}
                      >
                        {" "}
                        {p.charAt(0).toUpperCase() + p.slice(1)}
                      </p>
                    );
                  })}
              </>
            )}
            {focusedNode?.data.recommendedPreparation && (
              <div>
                <p className="text-lg">Recommended Preparation</p>
                <p className="font-bold bg-green-300 p-2">
                  {focusedNode?.data.recommendedPreparation}
                </p>
              </div>
            )}
            {focusedNode?.data.exclusions && (
              <div>
                <p className="text-lg">Exclusions</p>
                <p className="font-bold bg-red-300 p-2">
                  {focusedNode?.data.exclusions}
                </p>
              </div>
            )}

            {focusedNode?.data.corequisite && (
              <div>
                <p className="text-lg">Corequisite</p>
                <p className="font-bold bg-orange-300 p-2">
                  {focusedNode?.data.corequisite}
                </p>
              </div>
            )}
            {focusedNode?.data.comments && (
              <div>
                <p className="font-bold bg-yellow-300 p-2">
                  {focusedNode?.data.comments}
                </p>
              </div>
            )}
          </div>
          {/* <div id='disclaimer' className='mt-3'>
            <em >Courses displayed may be subject to change, please check with the Academic Calendar for the latest information.</em>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export const ParseAreaToLabel = (area) => {
  switch (area) {
    case 0:
      return "Core";

    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
      return "Area " + area;
    case 7:
      return "Sci/Math";
    case 8:
      return "Req'd";
  }
};
